import { createAsyncAction } from 'src/redux/actions';

export const FetchOwners = createAsyncAction('dashboard/FETCH_OWNERS');
export const FetchAndSelectOwner = createAsyncAction(
  'dashboard/FETCH_AND_SELECT_OWNER'
);
export const CLEAR_FILTERED_OWNERS = `dashboard/CLEAR_FILTERED_OWNERS`;
export const SELECT_OWNER = `dashboard/SELECT_OWNER`;
